window.addEventListener("load", (event) => {
  document.querySelectorAll(".swatch-wrap.swatchprimarywrap .individual-option").forEach((element) => {
    element.addEventListener("click", (evt) => {
      const url = element.closest(".swatch").getAttribute("href");
      window.location.href = url;
    });
  });
  
  document.querySelectorAll(".swatch-wrap.swatchprimarywrap").forEach((element) => {
    element.addEventListener("mouseover", (evt) => {
      element.closest("a.collection-product").classList.add("disabled");
      element.closest("a.collection-product").addEventListener("click", (evt) => {
        evt.preventDefault();
        console.log('Cancel PDP redirect...');
      });
    });
    element.addEventListener("mouseout", (evt) => {
      element.closest("a.collection-product").classList.remove("disabled");
    });
  })
});